import { type FC, useMemo } from 'react';

import { SkeletonSVG } from '@vakantiesnl/components/src/atoms/Skeleton/SkeletonSVG';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { DEFAULT_SEARCH_RESULTS_SIZE } from '@vakantiesnl/services/src/stores/filtersStore';

import { useStyles } from './AccommodationList.style';
import { productCardSkeletonDesktop, productCardSkeletonMobile } from './assets';

/** Show 1 placeholder more to include the 1 Zoover deal per regular search page */
const skeletonsToShow = DEFAULT_SEARCH_RESULTS_SIZE + 1;

export const AccommodationListSkeleton: FC<{ amountToShow?: number }> = ({ amountToShow = skeletonsToShow }) => {
	const { isMobile } = useBreakpoints();
	const { classes } = useStyles();

	const skeletonSvg = useMemo(() => (isMobile ? productCardSkeletonMobile : productCardSkeletonDesktop), [isMobile]);

	return (
		<div>
			{Array.from(Array(amountToShow)).map((_, index) => (
				<SkeletonSVG key={index} svg={skeletonSvg} svgClassName={classes.accoTile} />
			))}
		</div>
	);
};
